import React from 'react';

interface NoAssetsDisplayProps {
  icon: string;
  title: string;
  description: string;
  compact?: boolean;
}

export function NoAssetsDisplay({ icon, title, description }: NoAssetsDisplayProps) {
  return (
    <div className="no-assets-display glass-card">
      <h2>
        <span className="material-symbols-outlined no-assets-icon">
          {icon}
        </span>{title}
      </h2>
      <p>
        {description}
      </p>
    </div>
  );
}
